import PortalPage from "@/components/PortalPage";

export default function VendorPortal() {
  return (
    <PortalPage
      portal="VENDOR"
      title="Sell to thousands of buyers. From one storefront."
      tagline="List your catalog, respond to RFQs, fulfill orders and get paid — all from a single, branded vendor portal."
      gradient="from-pink-700 via-fuchsia-900 to-black"
      heroBg="🏷️"
      accentColor="from-pink-400 to-fuchsia-400"
      benefits={[
        { title: "Built-in marketplace", body: "Get discovered by verified buyers and distributors across India." },
        { title: "Smart RFQ engine", body: "Respond, counter, win — with automated price ladders and stock-check." },
        { title: "Fulfillment-grade", body: "Pick, pack, dispatch with barcode + e-way bill in under 5 minutes." },
        { title: "Payment fast-lane", body: "Stripe + Razorpay collections, auto-reconciliation and instant invoices." },
        { title: "Branded storefront", body: "Custom domain, custom theme — your brand, our infrastructure." },
        { title: "Inherits org hierarchy", body: "Same role tree as Organization portal — switch roles, never relearn." },
      ]}
      features={[
        "Unlimited product listings (Premium+)",
        "Bulk catalog import (Excel + CSV)",
        "RFQ inbox with auto-quote suggestions",
        "Multi-warehouse stock sync",
        "GST-ready invoicing",
        "Stripe + Razorpay + UPI",
        "Custom domain storefront",
        "Real-time order notifications",
        "API + webhooks for ERP push",
        "Reviews & ratings (Premium+)",
        "Multi-currency (Enterprise)",
        "Dedicated CSM (Enterprise)",
      ]}
      faqs={[
        { q: "What's the commission?", a: "Zero commission on the Organization plan. Marketplace add-on is a flat ₹1,499/mo for Basic, included in Premium and above." },
        { q: "Can I keep my existing storefront?", a: "Yes — we provide embed widgets and full APIs to sync your existing site with TileSphere's order engine." },
        { q: "How fast can I list?", a: "Bulk import lets you list 10,000+ SKUs in under 30 minutes. Manual entry is 60 seconds per SKU." },
        { q: "Are buyer details masked?", a: "Until an order is placed. Post-order, full address and GSTN are shared for fulfillment." },
        { q: "Do you handle disputes?", a: "Yes — Premium+ plans get arbitrated dispute resolution within 7 working days." },
      ]}
    />
  );
}
